import { useEffect, useState } from "react";
import { equalTo, get, orderByChild, query } from "firebase/database";
import { enquiriesDbRef } from "../utils/dbRefs";
import { useAuth } from "../contexts/AuthContext";

export const useSupplierStats = () => {
    const { currentUser } = useAuth();

    const [monthlyGrowth, setMonthlyGrowth] = useState(0);
    const [currentMonthCount, setCurrentMonthCount] = useState(0);
    const [previousMonthCount, setPreviousMonthCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGrowth = async () => {
            if (!currentUser?.uid) return;

            try {
                setLoading(true);

                const snapshot = await get(query(enquiriesDbRef, orderByChild("shopId"), equalTo(currentUser.uid)));

                if (!snapshot.exists()) {
                    setMonthlyGrowth(0);
                    setCurrentMonthCount(0);
                    setPreviousMonthCount(0);
                    return;
                }

                const data = snapshot.val();

                const enquiries = Object.values(data);

                const now = new Date();

                const currentMonth = now.getMonth();
                const currentYear = now.getFullYear();

                const previousMonth =
                    currentMonth === 0 ? 11 : currentMonth - 1;

                const previousYear =
                    currentMonth === 0
                        ? currentYear - 1
                        : currentYear;

                const currentCount = enquiries.filter((item) => {
                    if (!item.createdAt) return false;

                    const date = new Date(item.createdAt);

                    return (
                        date.getMonth() === currentMonth &&
                        date.getFullYear() === currentYear
                    );
                }).length;

                const previousCount = enquiries.filter((item) => {
                    if (!item.createdAt) return false;

                    const date = new Date(item.createdAt);

                    return (
                        date.getMonth() === previousMonth &&
                        date.getFullYear() === previousYear
                    );
                }).length;

                let growth = 0;

                if (previousCount === 0) {
                    growth = currentCount > 0 ? 100 : 0;
                } else {
                    growth =
                        ((currentCount - previousCount) /
                            previousCount) *
                        100;
                }

                setCurrentMonthCount(currentCount);
                setPreviousMonthCount(previousCount);
                setMonthlyGrowth(Number(growth.toFixed(0)));
            } catch (error) {
                console.error(
                    "Error calculating enquiry growth:",
                    error
                );
            } finally {
                setLoading(false);
            }
        };

        fetchGrowth();
    }, [currentUser?.uid]);

    return {
        monthlyGrowth,
        currentMonthCount,
        previousMonthCount,
        loading,
    };
};
